<div class="info-container {{lang.direction}}" >

  <mat-chip-list>
    <mat-chip *ngFor="let rel of tagCollection.items" (click)="relationClick(rel)">
      {{languageService.translate(rel , 'title' , lang.code ) }}
    </mat-chip>
  </mat-chip-list>

</div>
